// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_r4k","type":"styles_type__2k-2X","choices":"styles_choices__vmU7n"};